import { FinancesContainer } from '../containers/FinancesContainer/index'

export const FinancesPage = () => (
    <FinancesContainer/>
)